import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { apiList, getApiUrl } from 'src/app/core/Constants/apiList';
import { AllRolesFilter } from 'src/app/core/Models/interfaces/payloads/allRoles';
import { AllRulesFilter } from 'src/app/core/Models/interfaces/payloads/allRulesFilter';
import { UserManagePayload } from 'src/app/core/Models/interfaces/payloads/userManagePayload';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(
    private http: HttpClient,
  ) { }


  public getAllRules(filterPayload: AllRulesFilter): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.userManage.userList, filterPayload);
    return this.http.get<ApiResponse>(endpoint)
  }

  public getAllRoles(payloads?:AllRolesFilter): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.role.roles,payloads);
    return this.http.get<ApiResponse>(endpoint)
  }

  public getUserTypeBaseRoles(payload:{userType:number}): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.role.roles,payload);
    return this.http.get<ApiResponse>(endpoint)
  }

  public getUserDetails(id: number): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.userManage.userDetail, null, { id });
    return this.http.get<ApiResponse>(endpoint);
  }

  public addUser(payload: UserManagePayload): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.userManage.postUser);
    return this.http.post<ApiResponse>(endpoint, payload);
  }

  public editUser(payload: UserManagePayload, id: number): Observable<ApiResponse> {
    let endpoint = getApiUrl(`${apiList.userManage.postUser}/${id}`);
    return this.http.put<ApiResponse>(endpoint, payload);
  }

  exportList() {
    let endpoint = getApiUrl(apiList.userManage.dowloadUserLog);
    return this.http.get(endpoint, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }, responseType: 'blob', observe: 'response'
    });
  }

  public getPhyscianList(filterPayload: any): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.userManage.physcianList, filterPayload);
    return this.http.get<ApiResponse>(endpoint)
  }

  public getUserTypes(): Observable<ApiResponse> {
    let endpoint = getApiUrl(apiList.userManage.userType);
    return this.http.get<ApiResponse>(endpoint)
  }

}
